import { Box } from "../../box";
import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { NewTabIndicator } from "./NewTabIndicator";
import { useLink } from "./useLink";
import { useStyleProps } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "a";
export function InnerLink(props) {
  const [styleProps] = useStyleProps("link");
  const {
    active,
    as = DefaultElement,
    autoFocus,
    children,
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    shape = "rounded",
    target,
    ...rest
  } = mergeProps(props, styleProps);
  const {
    linkProps,
    showNewTabIndicator
  } = useLink({
    active,
    autoFocus,
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    shape,
    target
  });
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as
    }, linkProps),
    children: [children, showNewTabIndicator && /*#__PURE__*/_jsx(NewTabIndicator, {})]
  });
}
InnerLink.defaultElement = DefaultElement;
export const Link = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerLink, { ...props,
  forwardedRef: ref
}));